module.exports = __webpack_public_path__ + "img/blog-banner.ec08515.png";